import { css } from '@emotion/react';
import { fontSize, theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import EmptyStateIllustration from '../../assets/Empty-state-Illustration.png';

interface EmptyStateProps {
  description: string;
}

export const EmptyStates = ({ description }: EmptyStateProps) => {
  return (
    <div css={emptyStateStyles}>
      <img style={{ width: '265px', height: '254px' }} src={EmptyStateIllustration} />
      <Text
        css={css`
          font-size: ${fontSize(16)};
          max-width: 300px;
        `}
        textAlign='center'
        color='light'
      >
        {description}
      </Text>
    </div>
  );
};

const emptyStateStyles = css`
  display: flex;
  justify-content: center;
  min-height: 500px;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing(0)};
`;
